import React, { useEffect, useState } from "react";

type ToastType = "success" | "failed" | "warning" | "info";

interface ToastProps {
  type?: ToastType;
  message: string;
  duration?: number;
  onClose?: () => void;
}

const colorMap: Record<ToastType, string> = {
  success: "var(--color-pineGreen, #24AEA8)",
  failed: "#DC2626",
  warning: "#D97706",
  info: "#2563EB",
};

const Toast: React.FC<ToastProps> = ({
  type = "success",
  message,
  duration = 3000,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  const toastStyles: React.CSSProperties = {
    position: "fixed",
    bottom: "48px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1100,
    width: "798px",
    maxWidth: "calc(100vw - 48px)",
    height: "48px",
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid #D9D9D9",
    background: "var(--color-white, #FFF)",
    boxShadow:
      "0px 4px 8px -1px rgba(0, 0, 0, 0.1), 0px 1px 1px -1px rgba(0, 0, 0, 0.06)",
    display: "flex",
    alignItems: "center",
    fontFamily: "Interstate",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: colorMap[type],
  };

  return <div style={toastStyles}>{message}</div>;
};

export default Toast;
